

// src/redux/actions/leaveActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GET_LEAVE_TYPES_REQUEST = "GET_LEAVE_TYPES_REQUEST";
export const GET_LEAVE_TYPES_SUCCESS = "GET_LEAVE_TYPES_SUCCESS";
export const GET_LEAVE_TYPES_FAIL = "GET_LEAVE_TYPES_FAIL";

export const APPLY_LEAVE_REQUEST = "APPLY_LEAVE_REQUEST";
export const APPLY_LEAVE_SUCCESS = "APPLY_LEAVE_SUCCESS";
export const APPLY_LEAVE_FAIL = "APPLY_LEAVE_FAIL";

export const GET_LEAVE_STATUS_REQUEST = "GET_LEAVE_STATUS_REQUEST";
export const GET_LEAVE_STATUS_SUCCESS = "GET_LEAVE_STATUS_SUCCESS";
export const GET_LEAVE_STATUS_FAIL = "GET_LEAVE_STATUS_FAIL";

export const GET_REMAINING_LEAVES_REQUEST = "GET_REMAINING_LEAVES_REQUEST";
export const GET_REMAINING_LEAVES_SUCCESS = "GET_REMAINING_LEAVES_SUCCESS";
export const GET_REMAINING_LEAVES_FAIL = "GET_REMAINING_LEAVES_FAIL";

// Fetch Leave Types
export const fetchLeaveTypes = () => async (dispatch) => {
  dispatch({ type: GET_LEAVE_TYPES_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const designation = JSON.parse(localStorage.getItem("userProfile"))?.designation;
    const userID = JSON.parse(localStorage.getItem("userProfile"));

    const response = await axios.get(
      `${BASE_URL}/v1/api/get_remaining_leavesByAdmin/${userID?.id}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    dispatch({
      type: GET_LEAVE_TYPES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_LEAVE_TYPES_FAIL,
      payload: error?.response?.data?.message || error.message,
    });
  }
};

// Apply Leave
export const applyLeave = (formData) => async (dispatch) => {
  dispatch({ type: APPLY_LEAVE_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(`${BASE_URL}/v1/api/apply_leave`, formData, {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    });
console.log("responseresponse>>>",response);

    dispatch({
      type: APPLY_LEAVE_SUCCESS,
      payload: response.data,
    });

    toast.success(response?.data?.meta?.message);
    
  } catch (error) {
    dispatch({
      type: APPLY_LEAVE_FAIL,
      payload: error?.response?.data?.message || error.message,
    });

    toast.error(error?.response?.data?.message);
  }
};


// Fetch Leave Status
export const fetchLeaveStatus = () => async (dispatch) => {
  dispatch({ type: GET_LEAVE_STATUS_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${BASE_URL}/v1/api/leave_status`, {
      headers: {
        Authorization: token,
      },
    });

    dispatch({
      type: GET_LEAVE_STATUS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_LEAVE_STATUS_FAIL,
      payload: error?.response?.data?.message || error.message,
    });
  }
};


export const fetchRemainingLeaves = () => async (dispatch) => {
  dispatch({ type: GET_REMAINING_LEAVES_REQUEST });

  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${BASE_URL}/v1/api/remaining_leaves`, {
      headers: {
        Authorization: token,
      },
    });

    dispatch({
      type: GET_REMAINING_LEAVES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_REMAINING_LEAVES_FAIL,
      payload: error?.response?.data?.message || error.message,
    });
  }
};
